import { useEffect, useState } from "react";
import { Spin } from "antd";
import { useLoading } from "@ti/hooks";
import { history } from "@umijs/max";
import {
  DeployArea,
  DeployEnv,
  TiLogin,
  getDeployArea,
  getDeployEnv,
  useApp,
  useTiMaxStore,
  getDeployEnvArea,
  LoginType,
} from "@ti/max";
import { useAsyncEffect } from "ahooks";
import { useT } from "@/tiMax";
import { accountLogin, getCompanyList, loginWithCompany } from "@/services/user";
import getUserInfoFromResponse from "@/utils/getUserInfoFromResponse";
import packageInfo from "../../../package.json";

const loginUrlConfig = {
  dev_cn: "http://omc-web.dev.starcharge.cloud/login",
  test_cn: "http://omc-web.test.starcharge.cloud/login",
  test_sg: "http://omc-web.oversea-test.starcharge.cloud/login",
  prod_cn: "https://omc.starcharge.com/login",
  prod_sg: "https://omc-sg.starcharge.com/login",
  prod_us: "https://omc-us.starcharge.com/login",
  prod_eu: "https://omc-eu.starcharge.com/login",
};

/**
 * 登录
 */
const Login = () => {
  const t = useT("layout");

  const { loading, runTask } = useLoading();

  const { setLoginInfo } = useTiMaxStore();

  const { message } = useApp();

  const deployEnvArea = getDeployEnvArea();

  const appId = "cli_a62db5b0ab1b500c";
  const loginUrl = process.env.RUNTIME_ENV === "development"
    ? "http://localhost:3920/login"
    : (loginUrlConfig[deployEnvArea] || "http://test-test-omc.starcharge.cloud/");

  // 美洲账号密码登录,其他均为飞书登录
  const [loginTypes, setLoginTypes] = useState(
    (["prod_us", "uat_sg"].includes(deployEnvArea) || process.env.RUNTIME_ENV === "development") ? ["account"] : ["feishu"],
  );
  const [count, setCount] = useState(0);

  const handleLogin = async (token, company) => {
    const task = loginWithCompany({
      token,
      companyId: company.id,
      regionId: company.list[0]?.id,
    });
    const { data } = await runTask(task);

    if (data.menuList.length === 0) {
      message.error(t("该用户没有菜单权限"));
    } else {
      const loginInfo = getUserInfoFromResponse(data);
      setLoginInfo(loginInfo);
      window.location.href = "/";
    }
  };

  useEffect(() => {
    if (count > 10) {
      setLoginTypes(["feishu", "account"]);
    }
  }, [count]);

  useAsyncEffect(async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      localStorage.setItem("publicIP", data.ip);
    } catch (error) {
      console.warn(error);
    }
  }, []);

  return (
    <Spin spinning={loading}>
      <div
        onClick={() => {
          setCount(count + 1);
        }}
        style={{
          width: 20,
          height: 30,
          backgroundColor: "transparent",
          position: "fixed",
          top: 26,
          left: 0,
        }}
      />
      <TiLogin
        appName={`OMC ${t("系统")}`}
        appVersion={packageInfo.version}
        backgroundImage="https://omc-file-qingdao.oss-cn-qingdao.aliyuncs.com/omc_sub_upload/2024/05/14/20240514-101247.jpg"
        loginRequest={(params) => {
          // 账号密码登录
          if (params.loginType === LoginType.Account) {
            params.type = 1;
          }
          // 飞书登录
          if (params.loginType === LoginType.Feishu) {
            params.type = 2;
          }
          delete params.loginType;
          return accountLogin({ ...params }).then((res) => {
            // 登录失败返回登录页
            if (res.code !== "200") {
              history.push("/login");
              return;
            }
            return Promise.resolve(res);
          });
        }}
        companyListRequest={getCompanyList}
        showSwitchLocale={
          ![DeployEnv.PROD].includes(getDeployEnv()) || getDeployArea() !== DeployArea.CN
        }
        showForgotPassword={false}
        onLogin={handleLogin}
        loginTypes={loginTypes}
        feishuParams={{
          appId,
          redirectUri: loginUrl,
        }}
      />
    </Spin>
  );
};

export default Login;
